import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { FetchAPI } from './fetch-api.js';
import { FetchProperties } from './fetch-types.js';
import { Fetch, FetchContainer } from './fetch.js';
const awesomeProperties = {
    api: FetchAPI,
    containers: [FetchContainer],
    name: 'Fetch',
    properties: FetchProperties,
    type: ComponentType.BEHAVIOR,
};
AwesomeComponent(awesomeProperties)(Fetch);
export * from './fetch-context.js';
export * from './fetch-types.js';
export { Fetch, FetchAPI, };
//# sourceMappingURL=index.js.map